<section id="private">
  <bingo-header />
  <bingo-ios-install-nudge />
  <router-outlet />
  <bingo-countdown-bar />
</section>
